<div class="home-products-container mt-1" *ngIf="events.casino1.includes(id)">
  <div class="row row5">
    <div class="col-md-2" (click)="_common.openLogin()" [routerLink]="env.isMobile ? ['/m/casino-detail', id, item.id] : ['/casino-detail', id, item.id]"  *ngFor="let item of data?.event_types;trackBy:trackByIndex;">
        <div class="d-inline-block casinoicons">
          <img src="https://speedcdn.io/assets/casinogames-new-v1/{{item?.id}}.webp" class="img-fluid">
          <div class="casino-name">{{item.name}}</div>
        </div>
    </div>
  </div>
</div>

<div class="home-products-container mt-1" *ngIf="events.iCasino.includes(id)">
  <div class="row row5">
    <div class="col-md-12" *ngIf="data">
      <tabset #parentTabs class="casino_tabs_ul">
        <tab id="goto-casino-{{i}}" *ngFor="let tabDt of data;let i=index;trackBy:trackByIndex;" (selectTab)="onSelectParent(i)">
          <ng-template tabHeading>
            {{tabDt?.name}}
            <!-- <img class="img-fluid" src="assets/img/icon/{{tabDt?.slug}}.png"> -->
          </ng-template>
          <div class="icasino_ul_tabs">
            <tabset class="">
                <tab id="tab1" *ngFor="let innerTabDt of tabDt.data;let j=index;trackBy:trackByIndex;" (selectTab)="onSelect(j)">
                    <ng-template tabHeading>
                      <img class="img-fluid" src="https://speedcdn.io/assets/int_tab_icons/{{innerTabDt?.slug}}.png">
                        {{innerTabDt.name}}
                    </ng-template>

                    <div class="row row-casino" *ngIf="tabId == j">
                      <div (click)="confirmBox(item, tabDt.name)" class="col-md-2 col-3" *ngFor="let item of innerTabDt.data;trackBy:trackByIndex;">
                        <div class="d-inline-block casinoicons">
                          <img [lazyLoad]="item.url_thumb ? item.url_thumb : item.image_path" class="img-fluid">
                          <div class="casino-name">{{item.name}}</div>
                        </div>
                      </div>
                    </div>
                </tab>
            </tabset>
          </div>
        </tab>
      </tabset>
    </div>
  </div>
</div>
  
<div class="home-products-container mt-1" *ngIf="events.intCasino.includes(id)">
  <div class="row row5">
    <div class="col-md-12" *ngIf="data">
      <tabset #parentTabs class="casino_tabs_ul">
        <tab id="goto-casino-{{i}}" *ngFor="let tabDt of data;let i=index;trackBy:trackByIndex;" (selectTab)="onSelectParent(i)">
          <ng-template tabHeading>
            {{tabDt?.name}}
            <!-- <img class="img-fluid" src="assets/img/icon/{{tabDt?.slug}}.png"> -->
          </ng-template>
          <div class="icasino_ul_tabs">
            <tabset class="">
                <tab id="tab1" *ngFor="let innerTabDt of tabDt.data;let j=index;trackBy:trackByIndex;" (selectTab)="onSelect(j)">
                    <ng-template tabHeading>
                      <img class="img-fluid" src="https://speedcdn.io/assets/int_tab_icons/{{innerTabDt?.slug}}.png">
                        {{innerTabDt.name}}
                    </ng-template>

                    <div class="row row-casino" *ngIf="tabId == j">
                      <div (click)="confirmBox(item, tabDt.name)" class="col-md-2 col-3" *ngFor="let item of innerTabDt.data;trackBy:trackByIndex;">
                        <div class="d-inline-block casinoicons">
                          <img [lazyLoad]="item.url_thumb ? item.url_thumb : item.image_path" class="img-fluid">
                          <div class="casino-name">{{item.name}}</div>
                        </div>
                      </div>
                    </div>
                </tab>
            </tabset>
          </div>
        </tab>
      </tabset>
    </div>
  </div>
</div>

  <app-loader *ngIf="isLoad" [isFpLoader]="false"></app-loader>